import { createReducer } from '@reduxjs/toolkit'
import { AccountProfileT } from 'types/model'
import { receiveAccountProfile } from 'model/actions'

const initialState = null as AccountProfileT | null

const reducer = createReducer(initialState, builder => {
  builder.addCase(receiveAccountProfile, (state, action) => action.payload)
})

export default reducer
